<template>
    <div class="locale-picker">
        <text-button
            v-for="language in languages"
            :key="language.id"
            :lang="language.id"
            :aria-label="language.label"
            class="flag"
            @click.prevent="selectedLanguage(language)"
        >
            <img :src="language.flag" alt="flag" />
        </text-button>
    </div>
</template>

<script>
import { loadLanguageAsync } from "@/i18n";
import TextButton from "@/components/elements/TextButton";

export default {
    components: {
        TextButton
    },
    computed: {
        languages() {
            const availableLanguages = JSON.parse(
                process.env.VUE_APP_AVAILABLE_LANGUAGES
            );

            const languageMap = [];

            if (availableLanguages.indexOf("da") !== -1) {
                languageMap.push({
                    id: "da",
                    label: "Skift til dansk sprog",
                    flag: require("@/assets/images/flags/da.png")
                });
            }

            if (availableLanguages.indexOf("de") !== -1) {
                languageMap.push({
                    id: "de",
                    label: "zur deutschen Sprache wechseln",
                    flag: require("@/assets/images/flags/de.png")
                });
            }

            if (availableLanguages.indexOf("en") !== -1) {
                languageMap.push({
                    id: "en",
                    label: "switch to English language",
                    flag: require("@/assets/images/flags/en.png")
                });
            }

            return languageMap;
        }
    },
    methods: {
        selectedLanguage(language) {
            this.$i18n.locale = language.id;
        }
    }
};
</script>

<style scoped>
.locale-picker {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.flag {
    padding: 0;
    line-height: 0;
    margin: 0;
    margin-right: 5px;
    background: none;
}

.flag:hover {
    background: none;
}

.flag > img {
    width: 1.5rem;
}
</style>
